import { type ReactNode } from "react";
import { ReactQueryProvider } from "./ReactQueryProvider";
import { ThemeProvider } from "./ThemeProvider";
import { Toaster } from "@/design-system/components/ui/sonner";

interface Props {
  children: ReactNode;
}

export function AppProviders({ children }: Props) {
  return (
    <ReactQueryProvider>
      <ThemeProvider>
        {children}
        {/* El Toaster fuera de AuthBootstrap para que siempre sea visible */}
        <Toaster position="top-right" richColors closeButton />
      </ThemeProvider>
    </ReactQueryProvider>
  );
}
